import Vue from 'vue'
import { AMBIENTE_EDITOR, store } from './Store/Store'
import App from './Vue/App.vue'
import '@Shared/Lang'
import '@Shared/TrixAttachment'
import '@App/Vue/Directives/LongClick'
import { mobile } from '@Shared/Device'
import AparênciaPadrão from './Store/AparênciaPadrão'

import AloPurifiedHtml from '@App/Vue/Alo/PurifiedHtml.vue'
import AloIcon from '@App/Vue/Alo/Icon'
import AloAvatar from '@App/Vue/Alo/Avatar'
import AloCronômetro from '@App/Vue/Alo/Cronômetro'
import AloDropdown from '@App/Vue/Alo/Dropdown'
import AloLoadingRing from '@App/Vue/Alo/LoadingRing'
import AloDotsFlashing from '@App/Vue/Alo/DotsFlashing'
import RemoteEmojiPicker from '@App/Vue/Remote/EmojiPicker.vue'

Vue.component('alo-icon', AloIcon)
Vue.component('alo-avatar', AloAvatar)
Vue.component('alo-purified-html', AloPurifiedHtml)
Vue.component('alo-dropdown', AloDropdown)
Vue.component('alo-cronômetro', AloCronômetro)
Vue.component('remote-emoji-picker', RemoteEmojiPicker)
Vue.component('alo-loading-ring', AloLoadingRing)
Vue.component('alo-dots-flashing', AloDotsFlashing)
Vue.config.ignoredElements = ['trix-editor', 'teclia-trix-attachment']

window.Teclia = {
    /**
     * Aparância default caso nenhuma seja especificada.
     */
    defaultAppearance: AparênciaPadrão,

    /**
     * Inicializa uma nova instância do componente no elemento especificado.
     * Essa função deve ser chamada uma única vez quando a página for carregada.
     *
     * @param {HTMLElement} container
     */
    mount(container) {
        let ComponentClass = Vue.extend(App)

        let instance = new ComponentClass({
            store,
        })

        instance.$mount()
        container.appendChild(instance.$el)

        window.addEventListener('focus', () => {
            setTimeout(() => {
                store.dispatch('atualizarFoco', true)
            })
        })

        window.addEventListener('blur', () => {
            store.dispatch('atualizarFoco', false)
        })
    },

    /**
     * Atualiza a aparência do Widget e re-renderiza a instância do Vue.
     *
     * @param  {any} appearance Mapa com a descrição da aparência.
     * @return {void}
     */
    updateAppearance(appearance) {
        store.commit('atualizarAparência', appearance)
    },

    /**
     * Atualiza os departamentos que o usuário pode iniciar a conversa.
     *
     * @param  {any} departaments Mapa com a descrição da aparência.
     * @return {void}
     */
    updateDepartments(departaments) {
        store.commit('atualizarDepartamentos', departaments)
    },

    /**
     * Adiciona as seguintes chave-valor no perfil.
     */
    mergeProfile(profile) {
        Object.keys(profile).forEach(key => {
            store.commit('atualizarPerfil', { chave: key, valor: profile[key] })
        })
    },

    /**
     * Habilita o convite para se tornar visível.
     * Relevante somente para o widget incorporado.
     */
    hideInvite() {
        store.commit('setInviteVisibility', false)
    },

    /**
     * Habilita o convite para se tornar visível.
     * Relevante somente para o widget incorporado.
     */
    showInvite() {
        store.commit('setInviteVisibility', true)
    },

    /**
     * Abre a janela do atendimento. Equivalente a clicar no convite.
     */
    open() {
        store.dispatch('clicarNoConvite')
    },

    /**
     * Informações sobre o perfil do contato que temos hoje.
     */
    getProfile() {
        return JSON.parse(JSON.stringify(store.state.perfil))
    },

    /**
     * Qtde de atendimentos ativos.
     *
     * @returns {number}
     */
    getActiveRoomsCount() {
        return store.getters.activeRooms.length
    },

    /**
     * Atualiza a qtde máxima de atendimentos simultâneos que o contato pode abrir.
     *
     * @param {number} n
     */
    setMaxAmountOfActiveRooms(n) {
        store.commit('updateMaxAmountOfActiveRooms', n)
    },

    /**
     * Permite a abertura de novos atendimentos somente por chamadas de API.
     */
    onlyAllowNewChatRoomsFromAPICalls() {
        store.commit('updateOnlyAllowNewRoomsFromAPICalls', true)
    },

    /**
     * Tenta iniciar um novo atendimento se todos os parâmetros existirem.
     *
     * @param {string} firstMessage
     */
    async startChatRoom(firstMessage) {
        if (
            store.state.perfil.department_code &&
            ((store.state.perfil.name && store.state.perfil.email) || store.state.contato)
        ) {
            let existingRoom = store.state.salasByTab['chat'][0]
            if (existingRoom) {
                // Se o usuário recarregou acessou a página que inicia o atendimento com parâmetros diferentes,
                // nós devemos esquecer da sala antiga e voltar a acessar a sala atual.
                if (
                    existingRoom.atributos_extras.opening_parameters.name != store.state.perfil.name ||
                    existingRoom.atributos_extras.opening_parameters.email != store.state.perfil.email
                ) {
                    // Esquecer da sala atual para dar vez para a nova..
                    store.commit('deleteChatRoom', existingRoom.id)
                }
            }

            if (store.state.salasByTab['chat'].length >= store.state.maxAmountOfActiveRooms) {
                store.dispatch('selecionarSala', store.state.salasByTab['chat'][0])
                return
            }

            await store.dispatch('loadDepartamentsAvailability')

            let department = store.state.departamentos.find(d => d.code == store.state.perfil.department_code)
            if (!department) {
                console.warn('Could not find department from code: ' + store.state.perfil.department_code)
                return
            }

            let available = store.getters.availableDepartments.find(d => d.id == department.id)

            if (!available || !store.getters.estamosEmHorarioDeTrabalho) {
                console.warn('Could not start new chat room: department is not available')
                store.commit('atualizarEtapa', 'home')
                return
            }

            store.commit('iniciarConversaApósIdentificação', department.token)

            store.dispatch('abrirAtendimentoOuEnviarMensagemParaSalaSelecionada', {
                corpo_html: firstMessage,
                corpo_texto: firstMessage,
            })

            store.commit('atualizarEtapa', 'conversa')
        } else {
            console.warn('Required profile attributes: name, email and department_code.')
        }
    },

    /**
     * API privada usada pelo editor para atualizar a etapa do widget.
     *
     * @param {string} etapa
     * @return {void}
     */
    __updateStep(etapa) {
        store.commit('atualizarEtapa', etapa)
    },

    /**
     * Atualiza o estado interno o widget para "rodando no editor".
     *
     * Quando o widget está rodando dentro do editor, algumas coisas mudam. O layout muda ligereiramente (h-screen, por exemplo)
     * e os eventos são ignorados para que não seja possível iniciar uma conversa.
     */
    __updateEnvironmentToEditor() {
        store.commit('atualizarAmbiente', AMBIENTE_EDITOR)
    },

    /**
     * Commit na store do editor.
     */
    __commit(event, data) {
        store.commit(event, data)
    },

    /**
     * Envia uma mensagem para o script que contém o iframe. Usado para armazenar valores no localStorage
     * e redimensionar o iframe.
     *
     * @return {void}
     */
    __postMessage(evento, dados) {
        parent.postMessage({ type: evento, ...dados }, '*')
    },
}

window.addEventListener('message', async message => {
    if (!message.data) return

    switch (message.data.type) {
        case 'boot':
            if (message.data.boot.webMessengerToken) {
                store.commit('atualizarWebMessengerToken', message.data.boot.webMessengerToken)
            }

            if (message.data.boot.timezone_offset) {
                store.commit('updateTimezoneOffset', message.data.boot.timezone_offset)
            }

            if (message.data.boot.working_hours) {
                store.commit('updateWorkingHours', message.data.boot.working_hours)
            }

            if (message.data.boot.appearance) {
                store.commit('atualizarAparência', message.data.boot.appearance)
            }

            if (message.data.boot.departaments) {
                store.commit('atualizarDepartamentos', message.data.boot.departaments)
            }

            if (message.data.boot.profile) {
                Object.keys(message.data.boot.profile).forEach(key => {
                    store.commit('atualizarPerfil', { chave: key, valor: message.data.boot.profile[key] })
                })
            }

            if (message.data.boot.maxAmountOfActiveRooms) {
                Teclia.setMaxAmountOfActiveRooms(parseInt(message.data.boot.maxAmountOfActiveRooms))
            }

            if (message.data.boot.maxActiveTicketsPerGroup) {
                store.commit('updateMaxActiveTicketsPerGroup', parseInt(message.data.boot.maxActiveTicketsPerGroup))
            }

            if (message.data.boot.groupTicketsBy) {
                store.commit('updateGroupTicketsBy', message.data.boot.groupTicketsBy)
            }

            if (message.data.boot.firstMessage) {
                Teclia.mergeProfile({ first_message: message.data.boot.firstMessage })
            }

            if (message.data.boot.onlyAllowNewChatRoomsFromAPICalls) {
                store.commit(
                    'updateOnlyAllowNewChatRoomsFromAPICalls',
                    message.data.boot.onlyAllowNewChatRoomsFromAPICalls
                )
            }

            if (message.data.boot.state) {
                await store.dispatch('restoreFromSerializedState', message.data.boot.state)

                if (message.data.boot.startChatRoom) {
                    setTimeout(() => {
                        Teclia.startChatRoom(message.data.boot.startChatRoom)
                    }, 1000)
                }
            } else {
                if (message.data.boot.startChatRoom) {
                    setTimeout(() => {
                        Teclia.startChatRoom(message.data.boot.startChatRoom)
                    }, 1000)
                }
            }

            if (message.data.boot.fullscreen) {
                store.dispatch('initFullscreen')
            }

            if (message.data.boot.forceInviteOnLoad) {
                store.dispatch('forceInviteOnLoad')
            }

            if (message.data.boot.width) {
                store.commit('updateMobile', mobile(message.data.boot.width))
            }

            let container = document.querySelector('#web-messenger')
            if (container) {
                Teclia.mount(container)
            }

        case 'window-focus':
            store.dispatch('atualizarFoco', true)
            break

        case 'window-blur':
            store.dispatch('atualizarFoco', false)
            break

        case 'invoke':
            let result = Teclia[message.data.invoke].apply(Teclia, message.data.arguments)
            if (message.data.reply) {
                Teclia.__postMessage('reply', {
                    reply: message.data.reply,
                    result: result,
                })
            }
    }
})
